import { create } from 'zustand';

interface LanguageState {
    isRecognizingLang: boolean;
    setIsRecognizingLang: (isRecognizing: boolean) => void;
    language: string | null;
    setLanguage: (language: string | null) => void;
}

export const useLanguageStore = create<LanguageState>((set) => ({
    isRecognizingLang: false,
    setIsRecognizingLang: (isRecognizing) => set({ isRecognizingLang: isRecognizing }),
    language: null,
    setLanguage: (language) => set({ language }),
}));
